<div class="ai-chatbot-loading">
  <div class="ai-chatbot-loading-interpreting">
    <div
      class="ai-chatbot-loading-interpreting-glow"
      [class.ai-chatbot-loading-interpreting-glow-back-forth]="
        loadingText === 'Generating presentations...'
      "
    ></div>
    <span class="ai-chatbot-loading-interpreting-text">{{
      loadingText ?? 'Thinking...'
    }}</span>
  </div>

  <div
    class="ai-chatbot-loading-generating"
    *ngIf="aiChatbotService.isLoadingTemplates"
  >
    <div #samplesContainer class="ai-chatbot-loading-generating-samples-row">
      <div
        class="ai-chatbot-loading-generating-sample ai-loading-background-pulse"
        [class.ai-chatbot-loading-generating-sample-hidden]="shownSamples < 1"
        [class.ai-chatbot-loading-generating-sample-single]="sseIsEditing"
        [class.portrait]="isPortrait"
      >
        <ng-container *ngIf="partialTemplates[0]?.content; else loadingGlow">
          <presentation-preview
            [templatePreviewHtml]="partialTemplates[0].content"
            [orientation]="partialTemplates[0].orientation"
            [disableAutoRefresh]="true"
            [disableInteraction]="true"
            [showBranding]="aiChatbotService.showBranding()"
          ></presentation-preview>
        </ng-container>
      </div>
      <ng-container *ngIf="!sseIsEditing">
        <div
          class="ai-chatbot-loading-generating-sample ai-loading-background-pulse"
          [class.ai-chatbot-loading-generating-sample-hidden]="shownSamples < 2"
          [class.portrait]="isPortrait"
        >
          <ng-container *ngIf="partialTemplates[1]?.content; else loadingGlow">
            <presentation-preview
              [templatePreviewHtml]="partialTemplates[1].content"
              [orientation]="partialTemplates[1].orientation"
              [disableAutoRefresh]="true"
              [disableInteraction]="true"
              [showBranding]="aiChatbotService.showBranding()"
            ></presentation-preview>
          </ng-container>
        </div>
        <div
          class="ai-chatbot-loading-generating-sample ai-loading-background-pulse"
          [class.ai-chatbot-loading-generating-sample-hidden]="shownSamples < 3"
          [class.portrait]="isPortrait"
        >
          <ng-container *ngIf="partialTemplates[2]?.content; else loadingGlow">
            <presentation-preview
              [templatePreviewHtml]="partialTemplates[2].content"
              [orientation]="partialTemplates[2].orientation"
              [disableAutoRefresh]="true"
              [disableInteraction]="true"
              [showBranding]="aiChatbotService.showBranding()"
            ></presentation-preview>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template #loadingGlow>
    <div class="ai-chatbot-loading-glow-container ai-loading-glow-container">
      <div class="ai-chatbot-loading-glow-spinner ai-loading-glow-spinner">
        <div
          class="ai-chatbot-loading-glow-circle ai-chatbot-loading-glow-circle-blue ai-loading-glow-circle ai-loading-glow-circle-square ai-loading-glow-circle-blue"
        ></div>
        <div
          class="ai-chatbot-loading-glow-circle ai-chatbot-loading-glow-circle-green ai-loading-glow-circle ai-loading-glow-circle-square ai-loading-glow-circle-green"
        ></div>
      </div>
    </div>
  </ng-template>
</div>
